<template>
  <v-container fluid fill-height justify-center>
    <v-layout
      id="signature-done-container"
      align-center
      justify-center
      column
      fill-height
    >
      <div>
        <h1 class="display-3 font-weight-bold text-center">
          Signature d'un document
        </h1>
        <div class="headline text-center mt-4" v-if="signature">
          Vous venez de procéder à la signature des documents : <br />
        </div>

        <div class="mt-4">
          <ul>
            <li
              v-for="document in signature.instances"
              v-bind:key="document.id"
            >
              {{ document.name }}
            </li>
          </ul>
        </div>

        <div v-if="!statusChanged && !signatureSaved">
          <div class="text-center mt-4">
            Veuillez patienter pendant que nous procédons à quelques
            vérifications.
          </div>
          <div class="text-center mt-2">
            <v-progress-circular
              indeterminate
              color="#ff7c5d"
            ></v-progress-circular>
          </div>
        </div>
        <div
          v-else-if="statusChanged && !signatureSaved"
          class="error text-center mt-4"
        >
          Votre signature n'a pu être enregistrée... Veuillez réessayer ou nous
          contacter.
        </div>
        <div v-else class="text-center mt-4">
          <div class="success">
            Nous avons bien pris en compte votre signature.
          </div>
          <div
            v-if="
              transaction.status === 'ARCHIVED' ||
                transaction.status === 'CLOSED'
            "
          >
            Vous pourrez retrouver les documents signés dans votre compte.<br />
            Vous pouvez désormais fermer cette fenêtre.
          </div>
          <div v-else-if="hasCoRequester">
            Lorsque votre co-demandeur aura signé les documents, ceux-ci seront
            disponibles dans votre compte.<br />
            Vous pouvez désormais fermer cette fenêtre.
          </div>
        </div>
      </div>
    </v-layout>

    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
  </v-container>
</template>

<script>
import { fetchHil } from "../utils";

export default {
  components: {},
  data() {
    return {
      projectId: null,
      transactionId: null,
      signatoryId: null,
      showError: false,
      statusChanged: false,
      signatureSaved: false,
      transaction: {},
      isChecking: false
    };
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    signature() {
      return this.$store.state.currentProject
        ? this.$store.state.currentProject.signatures.find(
            signature => signature.transactionId === this.transactionId
          )
        : {};
    },
    hasCoRequester() {
      return this.$store.state.currentProject.coEnabled;
    }
  },
  methods: {
    scheduleSignatureCheck() {
      setTimeout(() => this.updateSignatureStatus(), 10000);
    },
    async loadData() {
      const decodedParam = atob(this.$route.params.encodedParam);
      const [leaseId, transactionId, signatoryId] = decodedParam.split("_");

      // Assign the collected values
      this.projectId = leaseId;
      this.transactionId = transactionId;
      this.signatoryId = signatoryId;

      // Fetch the details of the project
      await this.$store.dispatch("fetchProject", {
        id: this.projectId
      });

      // Check if the status changed
      this.scheduleSignatureCheck();
    },
    async updateSignatureStatus() {
      if (!this.isChecking) {
        this.isChecking = true;
        let resp;
        try {
          resp = await fetchHil(
            `/signatures/status/${this.projectId}/${this.transactionId}`,
            { method: "PUT" }
          );
        } catch (e) {
          console.log(e);
          this.isChecking = false;
          this.scheduleSignatureCheck();
          return;
        } finally {
          this.isChecking = false;
        }

        if (!resp.ok) {
          this.statusChanged = true;
          this.signatureSaved = true;
          this.transaction = { status: "CLOSED" };
        } else {
          const result = await resp.json();

          if (result.statusChanged) {
            this.statusChanged = result.statusChanged;

            const signatory = result.transaction.signatories.find(
              item => +item.id === +this.signatoryId
            );
            this.signatureSaved = signatory.signed;
            this.transaction = result.transaction;
            return;
          }
        }
      }

      this.scheduleSignatureCheck();
    }
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
.error,
.success {
  color: white;
  font-weight: bold;
  padding: 10px;
}
#signature-done-container {
  max-width: 700px;
}
</style>
